import requestor from "requestor";
import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import ActionTypes from "../constants/action_types";

/* eslint-disable max-params */
export default createReduxPromiseAction(
  ActionTypes.DOCUMENT_TEXT_REPLACE,
  (organisationId, projectId, documentId, find, replace) =>
    requestor
      .post(
        `${basePath}/organisation/${organisationId}/project/${projectId}` +
          `/document/${documentId}/replace`,
        {find, replace},
        {withCredentials: true},
      )
      .then(response => response.data),
);
